module.exports = __webpack_public_path__ + "media/img/pages/career-starter/07-64fa123b22d9235d5516b2b7cffef89b.png";